document.addEventListener("click", e => {
  if(e.target.matches(".js-disabled-cta")) {
    e.preventDefault();
  }
});
